<template>
  <div
    :class="$style.layoutStyleContainer"
  >
    <div :class="$style.colorPickerContainer">
      <ul
        :class="$style.colorContainer"
        role="menu"
      >
        <li
          v-for="color in colors"
          :key="color"
          :class="$style.colorOutline"
        >
          <div
            :class="[
              $style.color,
              { [$style.colorSelected]: isColorSelected(color) },
            ]"
            :style="{ 'background-color': color }"
            @click="handleColorChange(color)"
          >
            <i
              v-if="isColorSelected(color)"
              class="jc-check"
            />
          </div>
        </li>
      </ul>
      <div :class="$style.divider" />
      <AvatarColor
        :colorStyle="$style.colorStyle"
        :parentType="parentType"
      />
    </div>
  </div>
</template>
<script>
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import AvatarColor from 'client/components/Applications/AvatarColor.vue';

export default {
  name: 'ColorPicker',

  components: { AvatarColor },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    handleColorChange: {
      required: true,
      type: Function,
    },
  },

  data() {
    return {
      colors: [
        '#006CAC',
        '#202D38',
        '#005466',
        '#3E8696',
        '#0617AC',
        '#7C6ADA',
        '#D5779D',
        '#9E2F00',
        '#FFB000',
        '#58C469',
        '#57C49F',
        '#FF6C03',
      ],
    };
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    isColorSelected(color) {
      if (this.item) {
        const modelColor = this.item.logo.color || this.item.color;
        return modelColor === color;
      }
      return false;
    },
  },
};
</script>
<style module>
@import "../FormValidation/css/formFields.css";

.colorPickerContainer {
  display: flex;
}

.colorContainer {
  background-clip: padding-box;
  border: 0;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 16px 16px 12px 0;
  width: 120px;
}

.colorContainer li {
  margin: 4px 4px 4px 0;
}

.colorSelected {
  color: white;
}

.colorStyle {
  margin: 35px 26px !important;
}

.divider {
  background: var(--jcGrey200);
  margin: 29px 0;
  width: 2px;
}

.layoutStyleContainer {
  display: inline-block;
  font-size: 13px;
  position: relative;
  z-index: 1;
}

.samlIcon,
.color {
  border-radius: 15px;
  cursor: pointer;
  display: block;
  height: 20px;
  margin: 1px;
  width: 20px;
}

.color {
  align-items: center;
  display: flex;
  justify-content: center;
}

.samlIcon {
  border: 1px solid var(--jc-border-color);
}
</style>
